/** Define as variaveis utilizadas para renderizar na tabela inicial */
export class HardwaresTable {
    constructor(
        public id: string ,
        public name: string | null,
        public version: string | null,
        public releaseDate: Date | null,
    ){}
}